export default {
  title: 'Horarios y ubicación',
  set_different_opening_hours: 'Establecer horarios de apertura distintos para entregas',
  delivery_opening_hours: 'Horario de apertura para entregas',
  sections: {
    general: 'Horario general de apertura',
    holidays: 'Pausar pedidos (festivos)',
    create_time: 'Agregar horario de apertura',
    edit_time: 'Editar horario',
    delivery_schedule: 'Horario de apertura para entregas',
  },
  tabs: {
    open_times: 'Horarios de apertura',
    location: 'Ubicación',
  },
  form: {
    select_all: {
      label: 'Seleccionar todos los días',
    },
    holiday_starts_at: {
      label: 'Fecha de inicio',
    },
    holiday_ends_at: {
      label: 'Fecha de fin',
    },
    has_delivery_schedule: {
      label: 'Establecer horarios de apertura distintos para entregas',
    },
    has_multiple_locations: {
      label: 'Establecer distintas ubicaciones para la semana',
    },
  },
  labels: {
    day_location: 'Ubicación {{day}} {{index}}',
    selected_days: 'Días seleccionados',
    orders_paused: 'Pedidos pausados',
    open_time: 'Hora de apertura',
    close_time: 'Hora de cierre',
  },
  errors: {
    close_time: 'La hora de cierre no puede ser 00:00. Por favor ingrese 23:59',
  },
  buttons: {
    edit: 'Editar',
    add_schedule_unit: 'Agregar horario de apertura',
    add_holiday: 'Agregar festivo',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    changes_got_saved: 'Información actualizada correctamente',
    failed_to_save_changes: 'Error al guardar los cambios',
  },
};
